/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { KeyOfDictionary } from '@/types';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import langImage from '@/assets/images/icon_material_language.png';

interface Props {
  changeActive: (param: boolean) => void;
  isEnActive: boolean;
  translate: (keyWord: KeyOfDictionary) => string;
}

const LanguagePreferenceBarView = ({
  changeActive,
  isEnActive,
  translate,
}: Props) => {
  return (
    <div className="language-preference-bar">
      <div className="lpb-image-side">
        <img src={langImage} alt="" />
        <span>{translate('chooseLanguage')}</span>
      </div>
      <div className="lpb-switch-side">
        <div
          className={`lang en ${isEnActive ? 'active' : null}`}
          onClick={() => changeActive(true)}
          role="button"
        >
          <CheckCircleOutlineRoundedIcon className="checkIcon" />
          <span>EN</span>
        </div>
        <div
          className={`lang id ${isEnActive ? null : 'active'}`}
          onClick={() => changeActive(false)}
          role="button"
        >
          <CheckCircleOutlineRoundedIcon className="checkIcon" />
          <span>ID</span>
        </div>
      </div>
    </div>
  );
};

export default LanguagePreferenceBarView;
